import { createFinders } from '@wix/data-hooks-unidriver'
import {
  BadgeUniDriver,
  CheckboxUniDriver,
  HeadingUniDriver,
  ImageUniDriver,
} from '@wix/design-system/dist/testkit/unidriver'
import { UniDriver } from '@wix/unidriver-core'

import { RichTextDriver } from '../../../reusable/RichText'
import { dataHooks } from './AppItem.dataHooks'

export const AppItemDriver = <T>(base: UniDriver<T>) => {
  const { checkbox, image, builtInLabel, name, description } = createFinders(base, dataHooks)
  const checkboxDriver = CheckboxUniDriver(checkbox.find(), base)
  const badgeDriver = BadgeUniDriver(builtInLabel.find(), base)

  return {
    checkboxExists: checkboxDriver.exists,
    isChecked: checkboxDriver.isChecked,
    imageExists: ImageUniDriver(image.find(), base).exists,
    getName: HeadingUniDriver(name.find(), base).getText,
    builtInLabelExists: badgeDriver.exists,
    getBuiltInLabel: badgeDriver.text,
    getDescription: RichTextDriver(description.find(), base).getText,
    click: base.click,
  }
}
